import { IOfferSpendByAccountViewLang } from '../../../types/lang'
import { EOfferSpendByAccountView } from '../../../types'

export const offerSpendByAccountViewLang: IOfferSpendByAccountViewLang = {
	offer_spend_by_account_view: {
		[EOfferSpendByAccountView.Day]: 'day',
		[EOfferSpendByAccountView.Month]: 'month'
	}
}